export default "__VITE_ASSET__CyUkjD9w__"